import * as types from '../actions/types';
import { EVENT_FILTER_OPTIONS } from '../../constants/event-filters';

const initialState = {
    events: [],
    leagues: [],
    isFetching: false,
    sortType: EVENT_FILTER_OPTIONS.orders.byLeague.id,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case types.FAVORITES_EVENTS_RECEIVED:
            return { ...state, events: payload };
        case types.FAVORITES_EVENTS_TYPE_CHANGED:
            return { ...state, sortType: payload };
        case types.FAVORITES_LEAGUES_CHANGED: {
            return { ...state, leagues: payload };
        }
        default:
            return state;
    }
}
